import { useEffect, useState } from 'react';
import axios from 'axios';

function ParentAnnouncementsSection() {
    const token = sessionStorage.getItem('jwtToken');
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

    useEffect(() => {
        let mounted = true;

        const fetchAnnouncements = async () => {
            try {
                setLoading(true);

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/announcements/my`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (mounted) {
                    setAnnouncements(res.data.data || []);
                }
            } catch (error) {
                console.error('Fout bij ophalen mededelingen:', error);

                if (mounted) {
                    setAnnouncements([]);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        if (token) fetchAnnouncements();

        return () => {
            mounted = false;
        };
    }, [token]);

    // const formatDate = (value) => {
    //     if (!value) return null;
    //     return new Date(value).toLocaleDateString('nl-NL');
    // };

    if (loading || !announcements.length) {
        return null;
    }

    if (!announcements.length) {
        return null;
    }

    return (
        <>
            <section className="parent-announcements-section">
                <div className="parent-announcements-header">
                    <h3>Mededelingen</h3>
                    <span>{announcements.length}</span>
                </div>

                <div className="parent-announcements-list">
                    {announcements.map((item) => (
                        <button
                            key={item.announcement_id}
                            type="button"
                            className="parent-announcement-card"
                            onClick={() => setSelectedAnnouncement(item)}
                        >
                            <div className="parent-announcement-card__top">
                                <div className="parent-announcement-card__badge">Mededeling</div>
                                <div className="parent-announcement-card__icon">📌</div>
                            </div>

                            <div className="parent-announcement-card__content">
                                <h4>{item.title}</h4>

                                {item.body && (
                                    <p>
                                        {item.body.length > 110
                                            ? `${item.body.slice(0, 110)}...`
                                            : item.body}
                                    </p>
                                )}

                                {item.image_url && (
                                    <div className="parent-announcement-card__image-wrap">
                                        <img
                                            src={item.image_url}
                                            alt={item.title}
                                            className="parent-announcement-card__image"
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="parent-announcement-card__footer">
                                {/* <span>
                                    {item.visible_until
                                        ? `Zichtbaar t/m ${formatDate(item.visible_until)}`
                                        : 'Bekijk details'}
                                </span> */}
                                <span className="parent-announcement-card__arrow">→</span>
                            </div>
                        </button>
                    ))}
                </div>
            </section>

            {selectedAnnouncement && (
                <div
                    className="announcement-modal-backdrop"
                    onClick={() => setSelectedAnnouncement(null)}
                >
                    <div
                        className="announcement-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="announcement-modal__close"
                            onClick={() => setSelectedAnnouncement(null)}
                        >
                            ×
                        </button>

                        <h3>{selectedAnnouncement.title}</h3>

                        {selectedAnnouncement.body && (
                            <p className="announcement-modal__body">
                                {selectedAnnouncement.body}
                            </p>
                        )}


                        {selectedAnnouncement.document_url && (
                            <a
                                href={selectedAnnouncement.document_url}
                                target="_blank"
                                rel="noreferrer"
                                className="announcement-modal__document-link"
                            >
                                <i className="bi bi-paperclip me-2"></i>
                                {selectedAnnouncement.document_original_name || 'Document openen'}
                            </a>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default ParentAnnouncementsSection;